import { inject, Injectable } from '@angular/core'
import { ClientService } from '../../../services/domain/client/client.service'
import { Observable } from 'rxjs'
import { Client } from '../../../models/client'
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class ClientDropdownService {
  private clientService = inject(ClientService)

  getAllClients(): Observable<Client[]> {
    return this.clientService.getAllWithCaching().pipe(map((c) => c.sort(Client.sortByName)))
  }
}
